import { Pipe, PipeTransform } from '@angular/core';
import { PaymentPlanDefaults } from '../../payment-hub/model/payment-plan';

export interface PaymentEnum {
    id: number;
    label: string;
}

@Pipe({
    name: 'dateFormatter'
})
export class DateFormatterPipe implements PipeTransform {
    transform(date: any) {
        return new Date(date.year, date.month - 1, date.day);
    }
}


// @Pipe({
//     name: 'paymentFrequency'
// })
// export class PaymentFrequencyPipe implements PipeTransform {
//     transform(id: number) {
//         console.log(PaymentPlanDefaults.finadPaymentFrequency(id).label);
//         console.log(PaymentPlanDefaults.finadPaymentFrequency(id));
//         return PaymentPlanDefaults.finadPaymentFrequency(id).label;
//     }
// }